// NodeBrowseVisibility.js — hide host-pointer shells from normal browse surfaces

/**
 * True when the node is a Workspace host pointer (Google Doc/Sheet shell).
 * These stay in the graph for Attachments / Related / open-in-Google, but should
 * not appear as ordinary Documents/Files/Notes collection rows.
 *
 * @param {object|null|undefined} node
 * @returns {boolean}
 */
export function isHostPointerNode(node) {
  return Boolean(node && typeof node === 'object' && node.hostPointer === true);
}

/**
 * Drops host-pointer shells from a node list.
 *
 * @param {Array<object>|null|undefined} rows
 * @returns {Array<object>}
 */
export function filterOutHostPointerNodes(rows) {
  if (!Array.isArray(rows) || !rows.length) return [];
  return rows.filter((node) => !isHostPointerNode(node));
}
